import { LoanSelectProductScreen } from "@/screens/loans/setup/LoanSelectProductScreen"
import { router } from "expo-router"

export default function LoanSelectProduct() {
  return (
    <LoanSelectProductScreen
      backButton={() => {
        router.push("./property")
      }}
    />
  )
}
